import React from 'react'

export default function NotFound() {
    return (
        <div>
            <h1 className="display-4">404 Page not found</h1>
        </div>
    )
}
